<div class="modal-header panel-heading">
    <h2 class="modal-title">{{"contractComment.createNewTitle" | translate}}</h2>
    <button type="button" class="close" (click)="onClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="commentDataForm">
        <div class="form-group mt-lg px-2">
            <div class="row">
                <div>
                    <div class="form-label">
                        {{ "labels.comment" | translate }}
                    </div>
                    <quill-editor formControlName="comment" format="html" [modules]="modules" [styles]="{ height: '150px' }" class="w-100"></quill-editor>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="comment-modal-footer">
    <button class="btn btn-primary ml-3" (click)="onSave()">
        {{ "labels.save" | translate }}
    </button>
    <button class="btn btn-danger ml-3" (click)="onClose()">
        {{ "labels.cancel" | translate }}
    </button>
</div>